import { Entitlements } from '@protector/entities/licensing/constants';
import { getLicensingStatus, getSystemFlags } from 'core/core.selectors';
import { validatePlansAndEntitlements } from 'core/utils/functions';
import { isValidStressRiskLevel } from '@features/regional-overview/components/abiotic-stress-tag/abiotic-stress-tag.utils';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useRegionalRiskOverviewStore } from './regional-risk-overview.zustand';

interface AbioticStressVisibility {
  isAbioticStressFeatureFlagEnabled: boolean;
  hasAbioticStressEntitlement: boolean;
  hasAnyStressData: boolean;
  showAbioticStress: boolean;
  showMissingDataAlert: boolean;
}

export const useAbioticStressVisibility = (): AbioticStressVisibility => {
  const { filteredFeatures } = useRegionalRiskOverviewStore();
  const licensingStatus = useSelector(getLicensingStatus);
  const systemFlags = useSelector(getSystemFlags);
  const isAbioticStressFeatureFlagEnabled = Boolean(systemFlags?.P40_75056_ABIOTIC_STRESS_ON_DISEASE_RISK_RISK_MANAGEMENT);

  const hasAbioticStressEntitlement = validatePlansAndEntitlements(licensingStatus, null, [Entitlements.REGIONAL_RISK_ABIOTIC_STRESS]);

  const hasAnyStressData = useMemo(
    () => filteredFeatures.some(feature => isValidStressRiskLevel(feature.properties.values?.risks?.stress_risk_level?.level)),
    [filteredFeatures]
  );

  return {
    isAbioticStressFeatureFlagEnabled,
    hasAbioticStressEntitlement,
    hasAnyStressData,
    showAbioticStress: isAbioticStressFeatureFlagEnabled && hasAbioticStressEntitlement && hasAnyStressData,
    showMissingDataAlert:
      isAbioticStressFeatureFlagEnabled && hasAbioticStressEntitlement && !hasAnyStressData && filteredFeatures.length > 0
  };
};
